/**
 * Voice Rooms Service
 * API calls for voice room operations
 */

import { apiClient } from './api.client';
import type { VoiceRoom } from '@/types/voice-session.types';

export const listVoiceRooms = async (): Promise<VoiceRoom[]> => {
  const response = await apiClient.get<{ status: string; data: { rooms: VoiceRoom[] } }>('/voice/rooms');
  return response.data.data?.rooms || [];
};

export const createVoiceRoom = async (data: {
  name: string;
  description?: string;
  maxParticipants?: number;
}): Promise<VoiceRoom> => {
  const response = await apiClient.post<{ status: string; data: { room: VoiceRoom } }>('/voice/rooms', data);
  return response.data.data.room;
};

export const updateVoiceRoom = async (
  roomId: string,
  data: { name?: string; description?: string; maxParticipants?: number; position?: number; isArchived?: boolean }
): Promise<VoiceRoom> => {
  const response = await apiClient.put<{ status: string; data: { room: VoiceRoom } }>(`/voice/rooms/${roomId}`, data);
  return response.data.data.room;
};

export const deleteVoiceRoom = async (roomId: string): Promise<void> => {
  await apiClient.delete(`/voice/rooms/${roomId}`);
};

export const joinVoiceRoom = async (roomId: string): Promise<{
  session: { id: string; roomId?: string };
  token: string;
  liveKitUrl: string;
}> => {
  const response = await apiClient.post<{ session: { id: string; roomId?: string }; token: string; liveKitUrl: string }>(
    `/voice/rooms/${roomId}/join`
  );
  return response.data;
};

export const leaveVoiceRoom = async (roomId: string): Promise<void> => {
  await apiClient.delete(`/voice/rooms/${roomId}/leave`);
};
